import {LoadingSpinner} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';

import styles from './RenderedDocument.less';

interface OwnProps {
  formattedDocumentSnippets: React.ReactNode;
  isLoading: boolean;
}

type Props = OwnProps;

export const RenderedDocument: React.FC<Props> = (props) => {
  const {formattedDocumentSnippets, isLoading} = props;
  return (
    <div
      className={classNames(styles.dlRenderedDocument, 'dlLoadingSpinnerContainerOverflowed', {dlLoadingSpinnerParent: isLoading})}
      data-name={'loadingSpinnerParent'}
    >
      <LoadingSpinner isVisible={isLoading} text={'document.loading'} />
      <div style={{lineHeight: '21px'}}>{formattedDocumentSnippets}</div>
    </div>
  );
};

RenderedDocument.displayName = 'RenderedDocument';
